<div class="attachments-header">
  <div class="attachments-header-text">{{title}}</div>
  <a
    *ngIf="(filesReadOnly$ | async) === false"
    class="btn btn-link upload-button"
    (click)="upload.emit()"
  >
    <mat-icon>cloud_upload</mat-icon>
  </a>
</div>
<div
  class="attachments-list"
  *ngIf="attachments?.length > 0; else empty"
>
  <mat-card
    *ngFor="let element of attachments"
    class="attachment-card"
  >
    <div class="attachment-card-content">
      <mat-icon class="attach-icon">attachment</mat-icon>
      <div class="attachment-info">
        <div class="attachment-name"><a
            [href]="element?.path">{{ element?.name }}</a></div>
        <div class="attachment-details">by {{ element?.createdByName }}
          , {{ element?.createdDate | daysPassed : true }}</div>
      </div>
      <button
        *ngIf="(filesReadOnly$ | async) === false"
        class="btn btn-link more-button"
        [matMenuTriggerFor]="moreMenu"
        #trigger="matMenuTrigger"
        [ngClass]="{'active': trigger.menuOpened}"
        (menuOpened)="menuOpened()"
        (menuClosed)="menuClosed()"
      >
        <mat-icon
          class="more-icon"
          [ngClass]="{'active': trigger.menuOpen}"
        >more_horiz</mat-icon>
      </button>
    </div>
    <mat-menu
      #moreMenu="matMenu"
      class="more-menu no-padding"
      xPosition="before"
    >
      <button
        mat-menu-item
        class="menu-button"
        (click)="delete.emit(element.id)"
      >Remove</button>
    </mat-menu>
  </mat-card>
</div>
<ng-template #empty>
  <span class="no-results">{{ emptyMessage }}</span>
</ng-template>
